import React from 'react';
import { styles } from './Footer.css';

export type FooterProps = {
  leftContent: React.ReactNode | string;
  rightContent?: React.ReactNode | string;
};

export const Footer = ({ leftContent, rightContent }: FooterProps) => {
  return (
    <>
      <div className={styles.footerContainer}>
        <div className={styles.leftContent}>{leftContent}</div>
        {rightContent ? <div>{rightContent}</div> : null}
      </div>
    </>
  );
};
